module.exports = __webpack_public_path__ + "static/img/salesheet-uc.84b9b26.png";